import * as Sentry from "@sentry/react";
import { omit } from "ramda";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";

import {
  loadingNotifications,
  loadingNotificationsDone,
  setNotifications,
} from "./slice.js";

export const fetchNotifications =
  ({ page = 1, pageSize = 10 }) =>
  async (dispatch, getState) => {
    dispatch(loadingNotifications());

    const localAxios = createLocalAxios(getState);
    const url = `software-package/messages?page=${page}&page_size=${pageSize}`;

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error("Error while fetching notifications:", error);
      Sentry.captureException(error);
      throw error;
    } finally {
      await dispatch(loadingNotificationsDone());
    }

    await dispatch(setNotifications(response.data.softwareNotifications));

    return response.data.pages;
  };

export const saveSoftwareNotification =
  (values, softwareNotificationId) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const url = softwareNotificationId
      ? `software-package/message/${softwareNotificationId}`
      : `software-package/message`;
    let { tag } = values;

    if (!Array.isArray(tag)) {
      tag = Array.from(values.tag.split(/[ ,]+/));
    }

    const body = {
      ...omit(["createdAt", "updatedAt", "tag"], values),
      tag,
    };

    let response;
    try {
      if (softwareNotificationId) {
        response = await localAxios.patch(url, body);
      } else {
        response = await localAxios.post(url, body);
      }
    } catch (error) {
      console.error("Error while saving the software notification:", error);
      Sentry.captureException(
        new Error(
          `Something went wrong: softwareNotificationForm post/patch-> ${error}`,
        ),
      );
      throw error;
    }

    if (response.data.message !== apiMessages.MSG_SUCCESS) {
      throw new Error(response.data.message);
    }

    return response.data;
  };

export const removeSoftwareNotification =
  (softwareNotificationId) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const url = `software-package/message/${softwareNotificationId}`;

    try {
      await localAxios.delete(url);
    } catch (error) {
      console.error(`Error deleting software notification: ${error}`);
      Sentry.captureException(
        new Error(
          `Something went wrong: removeSoftwareNotification -> ${error}`,
        ),
      );
    }
  };

export const fetchSoftwareNotificationById =
  (identifier) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const url = `software-package/message/${identifier}`;

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error("Error while fetching the software package by id:", error);
      new Error(
        `Something went wrong: fetchSoftwarePackageById get -> ${error}`,
      );
    }

    dispatch(setNotifications([response.data]));
    return response.data;
  };
